import { DisciplineSubscriptionType } from './enums'
import { useDisciplinePaymentLinksStore } from './payment-links/store'
import {
  useDisciplineOrderCalculateApi,
  useDisciplineSubscriptionCalculateApi,
} from '../api/payment-calculate.hook'

interface DisciplinePaymentCalculateReturn {
  recalculate: () => Promise<void>
}

/** Legacy always billed installments monthly; the server may still store FOUR_WEEKS (see the calculate answer). */
export const PAYMENT_SUBSCRIPTION_TYPE = DisciplineSubscriptionType.Monthly

/** Refreshes the price table of the option on screen; without a selection there is nothing to price. */
export const useDisciplinePaymentCalculate = (): DisciplinePaymentCalculateReturn => {
  const route = useRoute()
  const store = useDisciplinePaymentLinksStore()

  const recalculate = async (): Promise<void> => {
    const disciplineId = route.params.id as string

    if (store.isOneTime) {
      const packageId = store.getPackageId
      if (!packageId) {
        store.setOrderCalculation(null)
        return
      }

      const result = await useDisciplineOrderCalculateApi({
        disciplineId,
        payload: { products: [packageId], discount: store.getDiscount },
      })
      if (result || store.getCalculationError) store.setOrderCalculation(result)
      return
    }

    const installmentId = store.getInstallmentId
    if (!installmentId) {
      store.setSubscriptionCalculation(null)
      return
    }

    const result = await useDisciplineSubscriptionCalculateApi({
      disciplineId,
      payload: { products: [installmentId], discount: store.getDiscount, type: PAYMENT_SUBSCRIPTION_TYPE },
    })
    if (result || store.getCalculationError) store.setSubscriptionCalculation(result)
  }

  return {
    recalculate,
  }
}
